import { Modal, Typography, Grid, Divider, makeStyles, Link, Popover, Button, Box, TableHead, TableCell, TableRow, Table, TableBody } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import * as dateFNS from 'date-fns';
import { formatValue } from 'react-currency-input-field';

import { MainContainer } from './styles';

const useStyles = makeStyles(() => ({
  divider: {
    margin: '1rem 0'
  }
}));

const formatPrice = (price) => {
  return formatValue({
    value: `${price}`,
    groupSeparator: '.',
    decimalSeparator: ',',
    prefix: 'R$'
  });
}

export default function BoletoModal({ isOpen, boleto, error, isLoading, onClose }) {
  const classes = useStyles();

  const handleClose = () => {
    onClose();
  }

  const statusMapper = {
    pending: 'Pendente'
  }
  return (
    <Modal open={isOpen} onClose={handleClose}>
      <MainContainer>
        <Typography variant="h6">Boleto Gerado</Typography>
        <Divider className={classes.divider} />
        {isLoading ? (
          <Box padding={4} display="flex" alignItems="center" justifyContent="center">
            <Typography variant="subtitle1">Carregando Boleto ...</Typography>
          </Box>
        ) : error ? (
          <Box padding={4} display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Typography variant="subtitle1" color="error" align="center">{error}</Typography>
            <Box marginTop={2}>
              <Button variant="outlined" color="primary" onClick={handleClose}>Fechar</Button>
            </Box>
          </Box>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID Pedido Pagarme</TableCell>
                <TableCell>Parcela</TableCell>
                <TableCell>Preço</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>URL</TableCell>
                <TableCell>Vencimento</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {boleto?.boletos?.map(boleto => {
                return (
                  <TableRow>
                    <TableCell>{boleto?.extras?.order_id}</TableCell>
                    <TableCell>{boleto?.extras?.installment}</TableCell>
                    <TableCell>{formatPrice(boleto?.price || '')}</TableCell>
                    <TableCell>{statusMapper[boleto?.status]}</TableCell>
                    <TableCell><a href={boleto?.url} target="_blank">{boleto?.url}</a></TableCell>
                    <TableCell>{dateFNS.format(new Date(boleto?.due_at), 'dd/MM/yyyy')}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </MainContainer>
    </Modal>
  );
}